import { useState } from 'react';
import { api } from '../api';

export default function ShareTrip() {
  const [shareUrl, setShareUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(null);

  const handleShare = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.createShareLink();
      const fullUrl = `${window.location.origin}${data.url}`;
      setShareUrl(fullUrl);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    if (!shareUrl) return;
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = shareUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!shareUrl) {
    return (
      <button
        onClick={handleShare}
        disabled={loading}
        className="bg-brand-ink/10 hover:bg-white/15 text-brand-ink/80 rounded-lg px-3 py-2 text-sm font-semibold transition-all disabled:opacity-50"
      >
        {loading ? 'Generating...' : 'Share Trip'}
      </button>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <input
          type="text"
          readOnly
          value={shareUrl}
          className="flex-1 min-w-0 px-3 py-2 bg-brand-ink/5 rounded-lg border border-brand-ink/10 text-sm text-brand-ink/75 outline-none"
        />
        <button
          onClick={handleCopy}
          className={`px-3 py-2 text-sm font-semibold rounded-lg transition-all whitespace-nowrap ${
            copied
              ? 'bg-teal/20 text-teal'
              : 'bg-brand-ink/10 hover:bg-white/15 text-brand-ink/80'
          }`}
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <div className="text-[11px] text-brand-ink/55">Link expires in 30 days</div>
      {error && <span className="text-danger text-xs">{error}</span>}
    </div>
  );
}
